module.exports = {
          srcSet: __webpack_public_path__ + "images/2003-6eb35fe44830437ac9eef432c9d8f409-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2003-d5438002ee9937f754180ed99aeb7fc8-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2003-6eb35fe44830437ac9eef432c9d8f409-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2003-d5438002ee9937f754180ed99aeb7fc8-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2003-6eb35fe44830437ac9eef432c9d8f409-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2003-6eb35fe44830437ac9eef432c9d8f409-320.jpg"},
          
          width: 320,
          height: 251
        }